module.exports = __webpack_public_path__ + "img/honnin-sev-title.529bca91.png";